/* Fork -- append to html instead of body to ensure scrollbar width is calculated if script runs before body tag parsed
*  better for unpredictable third party environment
* */

/*!
 * jQuery scrollbarWidth - v0.2 - 2/11/2009
 * http://benalman.com/projects/jquery-misc-plugins/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Calculate the scrollbar width dynamically!

(function($,undefined,width){
    '$:nomunge'; // Used by YUI compressor.

    $.scrollbarWidth = function() {
        var parent,
            child;

        if ( width === undefined ) {
            parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('html');
            child = parent.children();
            width = child.innerWidth() - child.height( 99 ).innerWidth();
            parent.remove();
        }
      
        return width;
    };

})(jQuery);




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/vendor/jquery.scrollbarWidth.js
 ** module id = 77
 ** module chunks = 0
 **/